<app-popup-layout #modal>
  @if (fetchUsageSettings.isCompleted()) {
    <div class="app-profile-mobile-otp">
      <div class="modal-body">
        <img
          class="mx-auto p-4"
          id="otp-image"
          src="/assets/svg/girl-mobile.svg"
          />
        <div class="text-center form-container">
          <span class="slim-ui-normal-text">
            Enter the OTP sent to <strong>{{ maskPhoneNumber(mobile) }}</strong>
          </span>
          <form [formGroup]="form" class="form-group otp-field-container">
            <ngx-otp-input
              #ngxotp
              (otpComplete)="patchOtpValue($event)"
              [options]="otpInputConfig"
            ></ngx-otp-input>
            <mat-error>
              <app-form-field-error
                [formControlRef]="form.get('otp')"
                [messages]="{
                  required: 'Please enter OTP',
                  pattern: '6 digit numbers are allowed'
                }"
                >
              </app-form-field-error>
            </mat-error>
            <div class="otp-resend text-end mb-5 mt-4">
              @if (!interval) {
                <a (click)="onResendOtp()">Resend OTP</a>
              }
              @if (interval) {
                <span> {{ timeLeft }} Seconds Left </span>
              }
            </div>
            <div class="form-group text-center pt-4">
              <button
                mat-flat-button
                color="primary"
                class="outline-button me-2"
                (click)="modal.dismiss()"
                type="button"
                >
                Cancel
              </button>
              <button
                mat-flat-button
                color="primary"
                class="ms-2"
                type="submit"
                [disabled]="form.invalid"
                [appLoaderButton]="formActionRequestState()"
                (click)="
                  onVerify.emit({
                    submitRequestState: submitRequestState,
                    otpValue: this.form.get('otp').value
                  })
                "
                >
                Verify
              </button>
              <div class="clearfix"></div>
            </div>
          </form>
        </div>
      </div>
    </div>
  }
</app-popup-layout>

@if (fetchUsageSettings.isPending()) {
  <div class="w-full pt-8">
    <app-slim-spinner class="m-auto"></app-slim-spinner>
  </div>
}
